export default __webpack_public_path__ + "static/media/forgotpwd-svg.9026afb6.svg";